import { ParsedUrlQuery } from 'querystring';

import { publicConfig } from '@public-config';

import { EmailHelpers } from 'helpers/EmailHelpers';

const URLHelpers = {
    /**
     * Returns the full CDN URL for a file.
     * @param path
     */
    file: (path: string) => {
        return publicConfig.urls.files + (path.startsWith('/') ? path : `/${path}`);
    },

    frontend: (path: string) => {
        return publicConfig.urls.frontend + (path.startsWith('/') ? path : `/${path}`);
    },

    getDomain: (url: string): string | null => {
        try {
            return new URL(url.trim()).hostname.replace(/^www\./, '');
        } catch {
            return null;
        }
    },

    normalizeWebsiteUrl: (url: string): string => {
        let normalized = url.toLowerCase().replace(/\/+$/, '');

        if (!/^https?:\/\//i.test(normalized)) {
            normalized = `http://${normalized}`;
        }

        return normalized;
    },

    emailMatchesWebsite: (email: string, website: string): boolean => {
        const emailDomain = EmailHelpers.getDomain(email);
        const websiteDomain = URLHelpers.getDomain(website);

        if (!emailDomain || !websiteDomain) {
            return false;
        }

        return emailDomain === websiteDomain || emailDomain.endsWith(`.${websiteDomain}`);
    },

    getServerSideParam: (params: ParsedUrlQuery = {}, key: string) => {
        const value = params[key];

        if (value && typeof value === 'string') {
            return value;
        }

        return null;
    },

    og: (logo: string) => {
        return `${publicConfig.urls.frontend}/api/og?logo=${encodeURIComponent(logo)}`;
    },

    pathMatches: (pathname: string, routes: string[]) =>
        routes.some((route) => pathname === route || pathname.startsWith(`${route}/`)),
};

export { URLHelpers };
